const FaqChildComponent = {
    data() {
        return {
            items: [],
            loading: false,
            activeIndex: -1,
        };
    },

    computed: {
        leftItems() {
            const mid = Math.ceil((this.items || []).length / 2);
            return (this.items || []).slice(0, mid);
        },

        rightItems() {
            const mid = Math.ceil((this.items || []).length / 2);
            return (this.items || []).slice(mid);
        },
    },

    methods: {
        async getFaq() {
            this.loading = true;

            try {
                const response = await window.faqService.getFaq({limit: 50, is_child: true});
                this.items = response?.data ?? [];

                this.activeIndex = this.items.length ? 0 : -1;

                await this.$nextTick();
                this.updateHeights();

            } catch (e) {
                console.error('[FAQ] getFaq failed', e);
                this.items = [];
                this.activeIndex = -1;
            } finally {
                this.loading = false;
            }
        },

        toggle(index) {
            this.activeIndex = this.activeIndex === index ? -1 : index;

            this.$nextTick(() => {
                this.updateHeights();
            });
        },

        updateHeights() {
            const accordions = this.$refs.accordions || [];

            accordions.forEach((accordion, index) => {
                const content = accordion.querySelector('.accordion__content');

                if (!content) return;

                if (index === this.activeIndex) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                    content.style.maxHeight = '0px';
                }
            });
        }
    },

    mounted() {
        this.getFaq();
    }
};

window.FaqChildComponent = FaqChildComponent;